import React, { useState } from "react";
import { useSelector } from "react-redux";
import TaskComment from "./TaskComment";
import { toast } from "react-toastify";
import { projectTaskCommentCreationService } from "../../../../services/projectDetails";

function TaskComments({ task, usersData }) {
  const [comment, setComment] = useState("");
  const [commentReply, setCommentReply] = useState(false);
  const [toggleView, setToggleView] = useState(true);
  const [taskData, setTaskData] = useState(task);
  const [isLoading, setIsLoading] = useState(false);

  const DetailedProjectData = useSelector((state) => state.projectDetails.getDetailedProjectData);

  const handleSubmitComment = async () => {
    if (!comment.trim()) {
      toast.error("Comment cannot be empty.");
      return;
    }

    setIsLoading(true); 

    const responseData = await projectTaskCommentCreationService({
      project_id: DetailedProjectData.project._id,
      task_id: task._id,
      userDetails: usersData._id,
      comments: comment,
      is_reply: false,
    });

    setIsLoading(false); 

    if (responseData?.status === 200) {
      toast.success(responseData.message);
      setComment(""); 
      setTaskData((prevTask) => ({
        ...prevTask,
        comments: [...prevTask.comments, { comment, user_id: usersData, replies: [] }],
      }));
    } else {
      toast.error(responseData.message);
    }
  };

  return (
    <div className="w-full bg-theme-cream py-4 px-2 rounded-theme-md">
      <div className="flex justify-between items-center">
        <p className="text-sm font-semibold text-theme-fg-1">
          Comments <span className="text-theme-accent">{taskData?.comments?.length || 0}</span>
        </p>
      </div>

      {toggleView && (
        <div className="mt-4 md:mx-6">
          <div className="flex items-center gap-2">
            <input
              className="border border-theme-cream-3 focus:border-theme-accent rounded-theme-sm px-3 py-2.5 w-full text-xs outline-none text-theme-fg-1"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Write your comment"
              disabled={isLoading}
            />
            <button
              onClick={handleSubmitComment}
              className={`${isLoading ? "": ""} bg-theme-ink hover:bg-theme-ink-2 px-4 py-2 text-white text-xs rounded-theme-sm flex items-center justify-center`}
              disabled={isLoading}
            >
              {isLoading ? (
                "Submitting"
              ) : (
                "Submit"
              )}
            </button>
          </div>
          <TaskComment task={taskData} setCommentReply={setCommentReply} commentReply={commentReply} setTask={setTaskData} />
        </div>
      )}
    </div>
  );
}

export default TaskComments;
